import { createAction } from '@reduxjs/toolkit';

// Action Types
export const SET_JOB_TITLE = 'jobEditor/setJobTitle';
export const SET_JOB_COUNTRY_NAME = 'jobEditor/setJobCountryName';
export const SET_JOB_COUNTRY_ID = 'jobEditor/setJobCountryId';
export const SET_JOB_MODE = 'jobEditor/setJobMode';
export const SET_JOB_TYPE = 'jobEditor/setJobType';
export const SET_JOB_CITY = 'jobEditor/setJobCity';
export const SET_JOB_STATUS = 'jobEditor/setJobStatus';
export const SET_ALL_JOB_PROPERTIES = 'jobEditor/setAllJobProperties';
export const SET_JOB_SLUG = 'jobEditor/setJobSlug';
export const SET_ORG_SLUG = 'jobEditor/setOrgSlug';

// Action Creators
export const setJobTitle = createAction<string>(SET_JOB_TITLE);
export const setJobCountryName = createAction<string>(SET_JOB_COUNTRY_NAME);
export const setJobCountryId = createAction<string>(SET_JOB_COUNTRY_ID);
export const setJobMode = createAction<string>(SET_JOB_MODE);
export const setJobType = createAction<string>(SET_JOB_TYPE);
export const setJobCity = createAction<string>(SET_JOB_CITY);
export const setJobStatus = createAction<string>(SET_JOB_STATUS);
export const setJobSlug = createAction<string>(SET_JOB_SLUG);
export const setOrgSlug = createAction<string>(SET_ORG_SLUG);
export const setAllJobProperties = createAction<Partial<JobEditorState>>(SET_ALL_JOB_PROPERTIES);

// Types
export interface JobEditorState {
  jobTitle: string;
  jobCountryName: string;
  jobCountryId: string;
  jobMode: string;
  jobType: string;
  jobCity: string;
  jobStatus: string;
  jobSlug: string;
  orgSlug: string;
}

// Initial State
export const initialState: JobEditorState = {
  jobTitle: '',
  jobCountryName: '',
  jobCountryId: '',
  jobMode: '',
  jobType: '',
  jobCity: '',
  jobStatus: '',
  jobSlug: '',
  orgSlug: ''
};
